import Pages from 'components/AppRouter/Pages'
import Page from 'shared/types/Page'
import InactivePage from 'pages/InactivePage'
import ReportPage from 'pages/ReportPage'
import { apiUrls } from 'consts'
import getAll from 'utils/getAll'
import { roles } from 'consts'

interface loadPagesProps {
  position?: string | boolean | undefined
  role: string
  customer?: any
  loadFromServer?: boolean
}

const loadPages = async (props: loadPagesProps) => {
  let allPages: Page[] = []
  const loadedPages: Page[] = []

  if (props.loadFromServer) {
    const sections = await getAll(apiUrls.actionGetMenuSections)

    await sections.map(async (section: any) => {
      if (section.active === 1) {
        const page: Page = {
          name: section.name,
          path: false,
          showInMenu: 'left',
          isDropdown: true,
          icon: section.icon,
          roles: [roles.user],
        }

        loadedPages.push(page)
      }
    })

    // fetch pages

    const pages = await getAll(apiUrls.actionGetMenuPages)

    pages.map((page: any) => {
      const newPage: Page = {
        name: page.name,
        path: '/' + page.url,
        parentPath: '#' + page.section_name,
        showInMenu: 'left',
        component: ReportPage,
        dropdownName: page.section_name,
        id: page.id,
        roles: [roles.user],
        staticContent: page.static_content,
        staticContentShort: '',
      }

      loadedPages.push(newPage)
    })
  } else if (props.customer) {
    const newPage: Page = {
      name: 'Portal Offline',
      path: '*',
      showInMenu: 'left',
      component: InactivePage,
      // id: page.id,
      roles: [roles.user],
      staticContent: props.customer.inactive_message,
    }

    loadedPages.push(newPage)
  }

  // add static pages
  allPages = loadedPages.concat(Pages)

  return allPages
}

export default loadPages
